import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78c488e5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-md-flex align-items-center justify-content-between" }
const _hoisted_2 = { class: "d-md-flex align-items-center" }
const _hoisted_3 = { class: "ticket-configuration__small-title mb-0" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-light-grey d-md-block d-none mx-2" }, "|", -1))
const _hoisted_5 = { class: "ticket-configuration__date my-2 my-md-0" }
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = { class: "ticket-configuration__status-text" }
const _hoisted_8 = { class: "card-body ticket-configuration__box-body p-0" }
const _hoisted_9 = {
  class: "row d-none d-md-flex",
  role: "row"
}
const _hoisted_10 = {
  class: "col-md-4",
  role: "columnheader"
}
const _hoisted_11 = { class: "ticket-configuration__box-label" }
const _hoisted_12 = {
  class: "col-md-2",
  role: "columnheader"
}
const _hoisted_13 = { class: "ticket-configuration__box-label" }
const _hoisted_14 = {
  class: "col-md-4",
  role: "columnheader"
}
const _hoisted_15 = { class: "ticket-configuration__box-label" }
const _hoisted_16 = {
  class: "col-md-2 text-end",
  role: "columnheader"
}
const _hoisted_17 = { class: "ticket-configuration__box-label" }
const _hoisted_18 = { class: "vertical-gutter gy-3" }
const _hoisted_19 = { class: "row gy-2 gy-md-0" }
const _hoisted_20 = { class: "col-md-4 col-6" }
const _hoisted_21 = { class: "ticket-configuration__box-label d-md-none" }
const _hoisted_22 = { class: "ticket-configuration__label" }
const _hoisted_23 = {
  key: 0,
  class: "text-success strong d-block d-md-inline-block"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn-popover btn-popover bg-danger ms-2" }, "!", -1))
const _hoisted_25 = { class: "font-default text-danger" }
const _hoisted_26 = { class: "col-md-2 col-6 text-end text-md-start flex-column align-items-end align-items-md-start d-flex" }
const _hoisted_27 = { class: "ticket-configuration__box-label d-md-none" }
const _hoisted_28 = { class: "col-md-4 col-6" }
const _hoisted_29 = { class: "ticket-configuration__box-label d-md-none" }
const _hoisted_30 = {
  key: 0,
  class: "text-price-before"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn-popover btn-popover bg-success" }, "%", -1))
const _hoisted_32 = { class: "col-md-2 col-6" }
const _hoisted_33 = { class: "ticket-configuration__box-label d-md-none text-end" }
const _hoisted_34 = { class: "text-end strong" }
const _hoisted_35 = { class: "ticket-configuration__total-wrapper text-end" }
const _hoisted_36 = { class: "ticket-configuration__total-label" }
const _hoisted_37 = { class: "ticket-configuration__total" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popper = _resolveComponent("Popper")!
  const _component_NumberSpinner = _resolveComponent("NumberSpinner")!
  const _component_AccordionItem = _resolveComponent("AccordionItem")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createBlock(_component_Accordion, { firstItemOpen: true }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateList, (dateListItem) => {
        return (_openBlock(), _createBlock(_component_AccordionItem, {
          disabled: dateListItem.availability.total === 0
        }, _createSlots({
          "accordion-trigger": _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(dateListItem.title), 1),
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.getLocaleDayOfMonthOfISO(dateListItem.date)) + ". " + _toDisplayString(_ctx.getLocaleMonthNameOfISO(dateListItem.date)) + " " + _toDisplayString(_ctx.getLocaleYearOfISO(dateListItem.date)), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", {
                  class: _normalizeClass('ticket-configuration__status is-'+dateListItem.availability.status)
                }, null, 2),
                _createElementVNode("span", _hoisted_7, _toDisplayString(dateListItem.availability.total) + " " + _toDisplayString(_ctx.translate('shop.configuration.ticket.available spaces')), 1)
              ])
            ])
          ]),
          _: 2
        }, [
          (dateListItem.availability.total !== 0)
            ? {
                name: "accordion-content",
                fn: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.translate('shop.configuration.ticket.age-group')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.translate('shop.configuration.ticket.sum-of-persons')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.translate('shop.configuration.ticket.price-per-unit')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.translate('shop.configuration.ticket.sum')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allPriceGroups, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "vertical-gutter__item ticket-configuration__box-separation",
                          key: item.value + 'price-groups'
                        }, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.translate('shop.configuration.ticket.age-group')), 1),
                              _createElementVNode("div", _hoisted_22, [
                                _createTextVNode(_toDisplayString(item.label) + " ", 1),
                                (_ctx.pricePerPriceGroup(item.value, dateListItem).priceGroupInfo )
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.pricePerPriceGroup(item.value, dateListItem).priceGroupInfo), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.pricePerPriceGroup(item.value, dateListItem).priceGroupWarning)
                                  ? (_openBlock(), _createBlock(_component_Popper, { key: 1 }, {
                                      content: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.pricePerPriceGroup(item.value, dateListItem).priceGroupWarning), 1)
                                      ]),
                                      default: _withCtx(() => [
                                        _hoisted_24
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.translate('shop.configuration.ticket.sum-of-persons')), 1),
                              _createVNode(_component_NumberSpinner, {
                                min: 0,
                                max: _ctx.getSelectedItemsCounter(_ctx.allPriceGroups, dateListItem),
                                value: _ctx.getCounter(item.value, dateListItem),
                                onChangeValue: (value, priceGroup) => _ctx.onChangeCounter(value, priceGroup, dateListItem),
                                changeId: item.value,
                                inputName: 'count-'+item.value,
                                inputId: 'count-'+item.value
                              }, null, 8, ["max", "value", "onChangeValue", "changeId", "inputName", "inputId"])
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.translate('shop.configuration.ticket.price-per-unit')), 1),
                              (_ctx.pricePerPriceGroup(item.value, dateListItem).priceBeforeDiscount)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.convertInCurrency(_ctx.pricePerPriceGroup(item.value, dateListItem).priceBeforeDiscount, _ctx.selectedCurrency)), 1))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(_ctx.convertInCurrency(_ctx.pricePerPriceGroup(item.value, dateListItem).price, _ctx.selectedCurrency)) + " ", 1),
                              (_ctx.pricePerPriceGroup(item.value, dateListItem).priceDiscountInfo)
                                ? (_openBlock(), _createBlock(_component_Popper, { key: 1 }, {
                                    content: _withCtx(() => [
                                      _createElementVNode("div", null, _toDisplayString(_ctx.pricePerPriceGroup(item.value, dateListItem).priceDiscountInfo), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _hoisted_31
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.translate('shop.configuration.ticket.sum')), 1),
                              _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.convertInCurrency(_ctx.getPriceGroupSum(_ctx.pricePerPriceGroup(item.value, dateListItem).price, _ctx.ticketConfiguration['priceGroupsPerDate'][dateListItem.date][item.value]?.counter), _ctx.selectedCurrency)), 1)
                            ])
                          ])
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.translate('shop.configuration.total-price')), 1),
                      _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.convertInCurrency(_ctx.getTotal(dateListItem), _ctx.selectedCurrency)), 1)
                    ])
                  ])
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["disabled"]))
      }), 256))
    ]),
    _: 1
  }))
}